import { render, staticRenderFns } from "./FAQStripe.vue?vue&type=template&id=03b21983&scoped=true"
import script from "./FAQStripe.vue?vue&type=script&lang=js"
export * from "./FAQStripe.vue?vue&type=script&lang=js"
import style0 from "./FAQStripe.vue?vue&type=style&index=0&id=03b21983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b21983",
  null
  
)

export default component.exports